// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Compose from "../Data.Functor.Compose/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Restaumatic_Form_Result from "../Restaumatic.Form.Result/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Base.bindDynamic);
var andThenA = /* #__PURE__ */ Restaumatic_Form_Result.andThenA(Specular_FRP_Base.applicativeDynamic);
var DynamicResult = function (x) {
    return x;
};
var functorDynamicResult = /* #__PURE__ */ Data_Functor_Compose.functorCompose(Specular_FRP_Base.functorDynamic)(Restaumatic_Form_Result.functorResult);
var map1 = /* #__PURE__ */ Data_Functor.map(functorDynamicResult);
var hasFieldDynamicResultDyna = function (dictHasField) {
    var getField = Data_Record.getField(dictHasField);
    return {
        getField: function (label) {
            return map1(getField(label));
        }
    };
};
var applyDynamicResult = /* #__PURE__ */ Data_Functor_Compose.applyCompose(Specular_FRP_Base.applyDynamic)(Restaumatic_Form_Result.applyResult);
var lift2 = /* #__PURE__ */ Control_Apply.lift2(applyDynamicResult);
var semigroupDynamicResult = function (dictSemigroup) {
    return {
        append: lift2(Data_Semigroup.append(dictSemigroup))
    };
};
var applicativeDynamicResult = /* #__PURE__ */ Data_Functor_Compose.applicativeCompose(Specular_FRP_Base.applicativeDynamic)(Restaumatic_Form_Result.applicativeResult);
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeDynamicResult);
var heytingAlgebraDynamicResu = function (dictHeytingAlgebra) {
    return {
        ff: pure(Data_HeytingAlgebra.ff(dictHeytingAlgebra)),
        tt: pure(Data_HeytingAlgebra.tt(dictHeytingAlgebra)),
        implies: lift2(Data_HeytingAlgebra.implies(dictHeytingAlgebra)),
        conj: lift2(Data_HeytingAlgebra.conj(dictHeytingAlgebra)),
        disj: lift2(Data_HeytingAlgebra.disj(dictHeytingAlgebra)),
        not: map1(Data_HeytingAlgebra.not(dictHeytingAlgebra))
    };
};
var monoidDynamicResult = function (dictMonoid) {
    var semigroupDynamicResult1 = semigroupDynamicResult(dictMonoid.Semigroup0());
    return {
        mempty: pure(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupDynamicResult1;
        }
    };
};
var additiveDynamicResult = function (dictAdditive) {
    return {
        zero: pure(Data_Numeric.zero(dictAdditive)),
        add: lift2(Data_Numeric.add(dictAdditive)),
        sub: lift2(Data_Numeric.sub(dictAdditive))
    };
};
var wrap = function ($50) {
    return DynamicResult(Data_Functor_Compose.Compose($50));
};
var unwrap = function (v) {
    return v;
};
var unsafeStrenghten = Unsafe_Coerce.unsafeCoerce;
var toTotal = /* #__PURE__ */ (function () {
    var $51 = map(Restaumatic_Form_Result.toTotal);
    return function ($52) {
        return $51(unwrap($52));
    };
})();
var toStrict = /* #__PURE__ */ (function () {
    var $53 = map(Restaumatic_Form_Result.toStrict);
    return function ($54) {
        return wrap($53(unwrap($54)));
    };
})();
var relax = function () {
    return Unsafe_Coerce.unsafeCoerce;
};
var toLax = /* #__PURE__ */ relax();
var over = function (f) {
    var $55 = map(f);
    return function ($56) {
        return wrap($55(unwrap($56)));
    };
};
var loadingStatus = /* #__PURE__ */ (function () {
    var $57 = map(Restaumatic_Form_Result.loadingStatus);
    return function ($58) {
        return $57(unwrap($58));
    };
})();
var liftResult = /* #__PURE__ */ (function () {
    var $59 = Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
    return function ($60) {
        return wrap($59($60));
    };
})();
var liftFinal = function () {
    return identity;
};
var liftDynamic = /* #__PURE__ */ (function () {
    var $61 = map(Control_Applicative.pure(Restaumatic_Form_Result.applicativeResult));
    return function ($62) {
        return wrap($61($62));
    };
})();
var errors = /* #__PURE__ */ (function () {
    var $63 = map(Restaumatic_Form_Result.errors);
    return function ($64) {
        return $63(unwrap($64));
    };
})();
var annotated = function (name) {
    var $65 = Specular_FRP_Base.annotated(name);
    return function ($66) {
        return wrap($65(unwrap($66)));
    };
};
var andThen = function (v) {
    return function (k) {
        return bind(v)(function (x) {
            return andThenA(x)(function ($67) {
                return unwrap(k($67));
            });
        });
    };
};
export {
    DynamicResult,
    andThen,
    liftResult,
    liftDynamic,
    liftFinal,
    wrap,
    unwrap,
    over,
    errors,
    loadingStatus,
    relax,
    unsafeStrenghten,
    annotated,
    toLax,
    toStrict,
    toTotal,
    functorDynamicResult,
    applyDynamicResult,
    applicativeDynamicResult,
    heytingAlgebraDynamicResu,
    semigroupDynamicResult,
    monoidDynamicResult,
    additiveDynamicResult,
    hasFieldDynamicResultDyna
};
